import {required} from "vuelidate/lib/validators";  
const StrIcDegerGiris = {
    data() {
      return {  
        
        IcDegerGirisData: { 
          "Deger": "",
          "Onay": 0,
          "Donemid": "",
          "Birimid": "",
          "Detayid": "", 
          "Deleted": false,
        }, 
          FormDataType:{
            Deger:{FieldName:"Deger",Field:"textarea",FieldTitle:'',FieldType:"text"}
          } 
      }
    }, 
    validations:{ 
      FormData: {  
        Deger: { required }
      }
 
  },
}
export default StrIcDegerGiris